module.exports = __webpack_public_path__ + "img/998.14a9ca0e.png";